"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shiftType = void 0;
const enums_1 = require("@bemlo/enums");
exports.shiftType = {
    [enums_1.ShiftType.REGULAR]: 'Regular',
    [enums_1.ShiftType.COMBINED]: 'Combined',
    [enums_1.ShiftType.ON_CALL]: 'On-Call',
};
